
const products = [
    {
        "name": "Scanned chicken-plate",
        "id": "chicken-plate",
        "info": {
            'model': ('https://dpwkb35ettjxj.cloudfront.net/models/cobotiks/ChickenWithPlate/ChickenWithPlate.glb'),
            'poster': ('https://dpwkb35ettjxj.cloudfront.net/models/cobotiks/ChickenWithPlate/poster.webp'),
            'arScale': 'fixed',
            'annotationStartsFrom':2,
            'shadowIntensity': '1',
            'shadowSoftness': '1',
            'exposure': '1',
            'cameraOrbit': '-19.56deg 36.57deg 0.4734m',
            'optionalAttr': {
                'arModes': 'webxr scene-viewer quick-look'
            }
        }
    },
    {
        "name": "burger-with-fries",
        "id": "burger",
        "info": {
            'model': ('https://dpwkb35ettjxj.cloudfront.net/models/cobotiks/BurgerWithFries/BurgerWithFries.glb'),
            'poster': ('https://dpwkb35ettjxj.cloudfront.net/models/cobotiks/BurgerWithFries/poster.webp'),
            'arScale': 'fixed',
            'annotationStartsFrom':1,
            'shadowIntensity': '1',
            'shadowSoftness': '1',
            'exposure': '1',
            'cameraOrbit': '-1.197deg 63.82deg 0.7895m',
            'optionalAttr': {
                'arModes': 'webxr scene-viewer quick-look'
            }
        }
    },
    {
        "name": "cake",
        "id": "cake",
        "info": {
            'model': ('https://dpwkb35ettjxj.cloudfront.net/models/cobotiks/Cake/CakeWithAnnot.glb'),
            'poster': ('https://dpwkb35ettjxj.cloudfront.net/models/cobotiks/Cake/poster.webp'),
            'arScale': 'fixed',
            'annotationStartsFrom':1,
            'shadowIntensity': '1',
            'shadowSoftness': '1',
            'exposure': '1',
            'cameraOrbit': '1.301deg 47.24deg 0.625m',
            'optionalAttr': {
                'arModes': 'webxr scene-viewer quick-look'
            }
        }
    },
    {
        "name": "Fast-food",
        "id": "fast-food",
        "info": {
            'model': ('https://dpwkb35ettjxj.cloudfront.net/models/cobotiks/FastFoodBeverage/FastFoodWithAnnot.glb'),
            'poster': ('https://dpwkb35ettjxj.cloudfront.net/models/cobotiks/FastFoodBeverage/poster.webp'),
            'arScale': 'fixed',
            'annotationStartsFrom':1,
            'shadowIntensity': '1',
            'shadowSoftness': '1',
            'exposure': '1',
            'cameraOrbit': '344deg 54.61deg 0.4841m',
            'optionalAttr': {
                'arModes': 'webxr scene-viewer quick-look'
            }
        }
    },
    {
        "name": "pie",
        "id": "LemonMeringuePie",
        "info": {
            'model': ('https://dpwkb35ettjxj.cloudfront.net/models/cobotiks/LemonMeringuePie/LemonMeringuePie.glb'),
            'poster': ('https://dpwkb35ettjxj.cloudfront.net/models/cobotiks/LemonMeringuePie/poster.webp'),
            'arScale': 'fixed',
            'annotationStartsFrom':1,
            'shadowIntensity': '1',
            'shadowSoftness': '1',
            'exposure': '1',
            'cameraOrbit': '-14.31deg 67.63deg 0.5728m',
            'optionalAttr': {
                'arModes': 'webxr scene-viewer quick-look'
            }
        }
    },
]

const getProduct = (id) => {
    return products.find(element=> element.id === id)
}

export {products, getProduct}